<template>
    <div :class="{ 'is-pinned': is_pinned }" :style="'top: ' + headerOffset + 'px'">
        <slot></slot>
    </div>
</template>

<script>
    import { debounce } from 'lodash'

    export default {
        props: {
            fixedClass: {
                type: String,
                default: 'sticky'
            },

            headerOffset: {
                type: Number,
                default: 0
            },

            offsetTop: {
                type: Number,
                default: 0
            },
        },

        data() {
            return {
                is_pinned: false,
            }
        },

        mounted() {
            this.calculatePin()

            window.addEventListener(
                'scroll',
                debounce(() => {
                    this.calculatePin()

                    this.$emit('scrolled', this.is_pinned)
                }, 10)
            )
        },

        methods: {
            calculatePin() {
                let originalOffsetTop = this.$el.getBoundingClientRect().top - this.headerOffset

                if(window.scrollY > originalOffsetTop) {
                    this.is_pinned = true

                    this.$el.classList.add(this.fixedClass)
                    this.$el.style.top = this.headerOffset
                }
                else {
                    this.is_pinned = false

                    if(this.headerOffset) {
                        this.$el.classList.remove(this.fixedClass)
                    }
                }
            },
        }
    }
</script>

<style scoped lang="sass">

</style>
